import { FC, useState } from 'react';
import { api, useApi } from '../api/api';
import IOApiTable, { IOApiTableActions } from '../components/IOApiTable';
import { Container } from 'semantic-ui-react';
import { ButtonCell, TextCell } from '../components/Table';
import { envColor } from '../common';


const VenueLibs: FC<{}> = () => {
    const [actions, setActions] = useState<IOApiTableActions>();
    const venueLibsApi = useApi(api.venueLibs);

    const name: string = envColor ?? '';

    return (
        <Container>
            <IOApiTable onInit={setActions} api={venueLibsApi} definition>
                <ButtonCell
                    header=''
                    icon='history'
                    onClick={actions?.historyFile}
                    value={lib => lib.key}
                    color={envColor}
                    button={{ basic: false }}
                />

                <ButtonCell
                    header=''
                    icon='trash'
                    onClick={actions?.remove}
                    value={_ => _}
                    color={envColor}
                    button={{ basic: false }}
                />
                <ButtonCell header='library' icon='arrow down' value={lib => lib.key} label={_ => _} onClick={actions?.read} color={envColor}/>
                <TextCell header='size' value={lib => lib.size} />
                <TextCell header='Uploader' value={lib => lib.author} />
                <TextCell header='Last Updated' value={lib => lib.created_at} />
            </IOApiTable>
        </Container>
    );
}


export default VenueLibs;